// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1zOxo","header":"styles_header__SwVWO","text":"styles_text__KbDCI","functionLayout":"styles_functionLayout__iB6Kw"};